import { FC, useMemo } from 'react';
import { AbsenceType, Attendee, ClassbookAttendeeListItem } from './ClassbookAttendeeListItem';
import { BpEventType } from 'components/EventsList/EventsList';
import dayjs from 'dayjs';
import { FragmentType, getFragmentData, graphql } from 'client/gql';

const ClassbookAttendeeListFieldsDocument = graphql(`
  fragment ClassbookAttendeeListFields on Query {
    absenceReasons(where: $absenceReasonsWhere) {
      uuid
      __typename
      reason
      internal
      absencesAggregate {
        __typename
        count
      }
    }
  }
`);

export type ClassbookAttendeeListProps = {
  event: BpEventType | null;
  attendees: Array<Attendee> | null;
  onAbsenceUpdate: (updatedAbsence: Partial<AbsenceType> & { comment?: string }) => Promise<void>;
  query: FragmentType<typeof ClassbookAttendeeListFieldsDocument> | undefined;
};

export const ClassbookAttendeeList: FC<ClassbookAttendeeListProps> = ({ event, attendees, onAbsenceUpdate, query }) => {
  const fragment = getFragmentData(ClassbookAttendeeListFieldsDocument, query);
  const absenceReasons = fragment?.absenceReasons;

  const reasons = useMemo(() => {
    return (
      absenceReasons?.map((r) => ({
        value: r.uuid,
        label: r.reason,
      })) ?? []
    );
  }, [absenceReasons]);

  return (
    attendees &&
    event &&
    attendees.map((attendee) => {
      return (
        <ClassbookAttendeeListItem
          key={attendee.uuid}
          onAbsenceUpdate={onAbsenceUpdate}
          attendee={attendee}
          reasons={reasons}
          start={event.start}
          end={dayjs(event.start).add(Number(dayjs.duration(Number(event.duration), 's')), 's')}
        />
      );
    })
  );
};
